import React from 'react'

const NonRealEstateReportIcon = () => {
  return (
    <svg
                  width="48"
                  height="49"
                  viewBox="0 0 48 49"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect y="0.5" width="48" height="48" rx="6" fill="#DBEAFE" />
                  <path
                    d="M30 14.5H18C16.8954 14.5 16 15.3954 16 16.5V32.5C16 33.6046 16.8954 34.5 18 34.5H30C31.1046 34.5 32 33.6046 32 32.5V16.5C32 15.3954 31.1046 14.5 30 14.5Z"
                    stroke="#2563EB"
                    strokeLinejoin="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M21 34.5V30.5H27V34.5"
                    stroke="#2563EB"
                    strokeLinejoin="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M20 18.5H20.01"
                    stroke="#2563EB"
                    strokeLinejoin="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M28 18.5H28.01"
                    stroke="#2563EB"
                    strokeLinejoin="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M24 18.5H24.01"
                    stroke="#2563EB"
                    strokeLinejoin="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M24 22.5H24.01"
                    stroke="#2563EB"
                    strokeLinejoin="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M24 26.5H24.01"
                    stroke="#2563EB"
                    strokeLinejoin="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M28 22.5H28.01"
                    stroke="#2563EB"
                    strokeLinejoin="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M28 26.5H28.01"
                    stroke="#2563EB"
                    strokeLinejoin="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M20 22.5H20.01"
                    stroke="#2563EB"
                    strokeLinejoin="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M20 26.5H20.01"
                    stroke="#2563EB"
                    strokeLinejoin="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
  )
}

export default NonRealEstateReportIcon